(ns quuppa.qsm.features)

(defn get-features []
  (js->clj js/feature_flags :keywordize-keys true))

(defn enabled? [feature]
  (get (get-features) feature false))
